import React, { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, Transition } from '@headlessui/react';

export default function ExitingModal({ isShowing, setIsShowing, setDashboardPartsSearch, setMorePartsModal }) {
    const navigate = useNavigate();
    return (
        <Transition.Root show={isShowing} as={Fragment}>
            <Dialog
                as='div'
                className='relative z-50'
                onClose={() => {
                    setIsShowing(false);
                    setDashboardPartsSearch(true);
                }}
            >
                <Transition.Child
                    as={Fragment}
                    enter='ease-out duration-300'
                    enterFrom='opacity-0'
                    enterTo='opacity-100'
                    leave='ease-in duration-200'
                    leaveFrom='opacity-100'
                    leaveTo='opacity-0'
                >
                    <div className='fixed inset-0 bg-gray-500 bg-opacity-90 transition-opacity' />
                </Transition.Child>

                <div className='overflow-y-auto fixed inset-0 z-10'>
                    <div className='flex justify-center items-center p-4 min-h-full text-center'>
                        <Transition.Child
                            as={Fragment}
                            enter='ease-out duration-300'
                            enterFrom='opacity-0 scale-95'
                            enterTo='opacity-100 scale-100'
                            leave='ease-out duration-200'
                            leaveFrom='opacity-100 scale-100'
                            leaveTo='opacity-0 scale-95'
                        >
                            <Dialog.Panel className='overflow-hidden relative w-full max-w-md transition-all transform'>
                                <div className='relative p-6 mx-4 w-full bg-white rounded-lg shadow-xl'>
                                    <div className='text-center'>
                                        <h3 className='mb-4 text-lg font-medium text-gray-900'>Are you sure?</h3>
                                        <p className='mb-6 text-sm text-gray-500'>
                                            Would you like to search for more parts?
                                        </p>

                                        <div className='flex justify-center space-x-3'>
                                            <button
                                                onClick={() => {
                                                    setIsShowing(false);
                                                    setDashboardPartsSearch(false);
                                                    navigate('/');
                                                    window.location.reload();
                                                }}
                                                className='px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500'
                                            >
                                                Exit
                                            </button>
                                            <button
                                                onClick={() => {
                                                    setIsShowing(false);
                                                    setMorePartsModal(true);
                                                    setDashboardPartsSearch(true);
                                                }}
                                                className='px-4 py-2 text-sm font-medium text-white rounded-md bg-blue-primary hover:bg-blue-secondary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-primary'
                                            >
                                                Search for more parts
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}
